import { useLocalStorage } from "@src/appV2/lib/utils";
import { isEqual } from "lodash";
import { useCallback, useMemo } from "react";

import { DEFAULT_STORED_FILTERS, VISIT_FILTERS_LOCAL_STORAGE_KEY } from "./constants";
import { type VisitStoredFilters } from "./types";

export function useStoredVisitFilters() {
  const [storedFilters, setStoredFilters] = useLocalStorage<VisitStoredFilters>(
    VISIT_FILTERS_LOCAL_STORAGE_KEY,
    DEFAULT_STORED_FILTERS
  );

  const clearStoredFilters = useCallback(() => {
    setStoredFilters(DEFAULT_STORED_FILTERS);
  }, [setStoredFilters]);

  const modifiedStoredFiltersCount = useMemo(
    () =>
      Object.keys(storedFilters).filter(
        (key) =>
          !isEqual(
            storedFilters[key as keyof VisitStoredFilters],
            DEFAULT_STORED_FILTERS[key as keyof VisitStoredFilters]
          )
      ).length,
    [storedFilters]
  );

  return {
    storedFilters,
    setStoredFilters,
    clearStoredFilters,
    modifiedStoredFiltersCount,
  };
}
